import React, { useEffect, useState } from 'react';
import { BASE_URL } from '../../Utils/base_url';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Spinner from 'react-bootstrap/Spinner';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import Select from 'react-select';
import { AjouteAdmin, AfficheAdmin, SuprimerAdmin, ModifierAdmin } from '../../Api/SocieteApi/AdminApi';
import { AjoutePromoMin, AffichePromoMin } from '../../Api/SocieteApi/DonnerRestaurantApi';
import {
  AjouteTypeCuisine, AfficheTypeCuisine, SuprimerTypeCuisine,
  AjouteQuartier, AfficheQuartier, SuprimerQuartier,
  AjouteCadre, AfficheCadre, SuprimerCadre,
  AjouteService, AfficheService, SuprimerService,
  AjouteRegime, AfficheRegime, SuprimerRegime,
  AjoutePayement, AffichePayement, SuprimerPayement,
  AjouteBoisson, AfficheBoisson, SuprimerBoisson,
  AjouteHero, AfficheHero, AfficheCritereAvis, AjouteCritereAvis, SuprimerCritere,
  AjouteRechercheRapide, AfficheRechercheRapide, AjoutePlusReserver, AffichePlusReserver

} from '../../Api/SocieteApi/DonnerRestaurantApi';
import { useSelector } from 'react-redux';
import './css/parametragePage.css';

const ParametragePage = () => {
  const [hero, setHero] = useState();
  const [heroUrl, setHeroUrl] = useState('');
  const [icon, setIcon] = useState(true);
  const [errorHero, setErrorHero] = useState('');


  const [loadAdmin, setLoadAdmin] = useState(false);
  const [loadAdminUpdate, setLoadAdminUpdate] = useState(false);
  const [loadDeleteAdmin, setLoadDeleteAdmin] = useState(false);
  const [loadData, setLoadData] = useState(false);
  const [loadCritere, setLoadCritere] = useState(false);
  const [critereAvis, setCritereAvis] = useState('');
  const [dataCritere, setDataCritere] = useState([]);

  const [admin, setAdmin] = useState([]);
  const [niveau, setNiveau] = useState('');
  const [nom, setNom] = useState('');
  const [prenom, setPrenom] = useState('');
  const [email, setEmail] = useState('');

  const [idUpdate, setIdUpdate] = useState('');
  const [niveauUpdate, setNiveauUpdate] = useState('');
  const [nomUpdate, setNomUpdate] = useState('');
  const [prenomUpdate, setPrenomUpdate] = useState('');
  const [emailUpdate, setEmailUpdate] = useState('');
  const [passwordUpdate, setPasswordUpdate] = useState('');

  const [show, setShow] = useState(false);


  const [dataNiveau, setDataNiveau] = useState([
    {
      id: 0,
      libelle: "Niveau",
      value: ""
    },
    {
      id: 1,
      libelle: "Niveau 1",
      value: "Niveau 1"
    },
    {
      id: 2,
      libelle: "Niveau 2",
      value: "Niveau 2"
    },
    {
      id: 3,
      libelle: "Niveau 3",
      value: "Niveau 3"
    }
  ]);


  const [typeCuisine, setTypeCuisine] = useState('');
  const [loadTypeCuisine, setLoadTypeCuisine] = useState(false);
  const [dataTypeCuisine, setDataTypeCuisine] = useState([]);

  const [quartier, setQuartier] = useState('');
  const [loadQuartier, setLoadQuartier] = useState(false);
  const [dataQuartier, setDataQuartier] = useState([]);

  const [cadre, setCadre] = useState('');
  const [loadCadre, setLoadCadre] = useState(false);
  const [dataCadre, setDataCadre] = useState([]);

  const [service, setService] = useState('');
  const [loadService, setLoadService] = useState(false);
  const [dataService, setDataService] = useState([]);

  const [regime, setRegime] = useState('');
  const [loadRegime, setLoadRegime] = useState(false);
  const [dataRegime, setDataRegime] = useState([]);

  const [payement, setPayement] = useState('');
  const [loadPayement, setLoadPayement] = useState([]);
  const [dataPayement, setDataPayement] = useState([]);

  const [boisson, setBoisson] = useState('');
  const [loadBoisson, setLoadBoisson] = useState([]);
  const [dataBoisson, setDataBoisson] = useState([]);




  const [rechercheRapide, setRechercheRapide] = useState([
    {
      id: 1,
      titre: "Ville",
      value: "",
      status: false,
    },
    {
      id: 2,
      titre: "Meilleures promo",
      value: "",
      status: false,
    },
    {
      id: 3,
      titre: "Mieux notés",
      value: "",
      status: false,
    },
    {
      id: 4,
      titre: "Nouveaux venus",
      value: "",
      status: false,
    },
    {
      id: 5,
      titre: "Les plus réservés",
      value: "",
      status: false,
    },
    {
      id: 6,
      titre: "Enfants bienvenus",
      value: "",
      status: false,
    },
    {
      id: 7,
      titre: "Rooftop",
      value: "",
      status: false,
    },
    {
      id: 8,
      titre: "En famille",
      value: "",
      status: false,
    },
    {
      id: 9,
      titre: "Spécial groupe +10 pers",
      value: "",
      status: false,
    },
    {
      id: 10,
      titre: "Type de cuisine",
      value: "",
      status: false,
    }
  ]);

  const [loadRechercheRapide, setLoadRechercheRapide] = useState(false);





  const [plusReserver, setPlusReserver] = useState([
    {
      id: 1,
      titre: "Ville",
      placeholder: 'Ville ...',
      value: "",
      status: false,
    },
    {
      id: 2,
      titre: "Cuisine",
      placeholder: 'Cuisine ...',
      value: "",
      status: false,
    }
  ]);


  const [loadPlusReserver, setLoadPlusReserver] = useState(false);


  const [selectPromoMin, setSelectPromoMin] = useState(null);
  const [promoMinOptions, setPromoMinOptions] = useState([
    { value: "1", label: "1 Jour" },
    { value: "2", label: "2 Jour" },
    { value: "3", label: "3 Jour" },
    { value: "4", label: "4 Jour" },
    { value: "5", label: "5 Jour" },
    { value: "6", label: "6 Jour" },
    { value: "7", label: "7 Jour" },
    { value: "8", label: "8 Jour" },
    { value: "9", label: "9 Jour" },
    { value: "10", label: "10 Jour" }
  ]);

  const [loadPromoMin, setLoadPromoMin] = useState(false);

  const customStyles = {
    control: (base, state) => ({
      ...base,
      border: state.isFocused ? '1px solid #dee2e6' : '1px solid #dee2e6',
      boxShadow: 'none',
      background: 'white',
      height: "38px",
      borderRadius: "8px",
      padding: '0px !important',
      fontWeight: 400,
      lineHeight: 1,
      margin: '0px!important',
      fontSize: '14px',
      cursor: 'pointer',
      '&:hover': {
        borderColor: '#deede6',
      },
    }),
    placeholder: (base) => ({
      ...base,
      color: '#595c5f',
      fontWeight: 390,
      marginLeft: '3px',
      fontSize: '14px'
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? '#0274fc' : 'white',
      color: state.isSelected ? 'white' : '#414141',
      cursor: 'pointer',
      fontSize: '14px'
    }),

  }

  let location = useLocation();
  const societe = useSelector((state) => state.societe);


  useEffect(() => {
    AfficheAdministration();
    AfficheTypeCuisineData();
    AfficheQuartierData();
    AfficheCadreData();
    AfficheServiceData();
    AfficheRegimeData();
    AffichePayementData();
    AfficheBoissonData();
    AfficheHeroData();
    AfficheCritere();
    AfficheCritereRechercheRapide();
    AfficheCriterePlusReserver();
    AffichePromotionMin();
  }, []);




  const AfficheAdministration = () => {
    setLoadDeleteAdmin(true);
    AfficheAdmin().then(function (response) {
      console.log('Liste Admin =>', response.data.donner);
      setAdmin(response.data.donner);
    }).catch(function (error) {
      console.log(error);
    }).finally(function () {
      setLoadDeleteAdmin(false);
    });
  }


  const AfficheTypeCuisineData = () => {
    setLoadTypeCuisine(true);
    AfficheTypeCuisine().then(function (response) {
      console.log('Liste Type cuisine =>', response.data.donner);
      setDataTypeCuisine(response.data.donner);
    }).catch(function (error) {
      console.log(error);
    }).finally(function () {
      setLoadTypeCuisine(false);
    });
  }


  const AfficheQuartierData = () => {
    setLoadQuartier(true);
    AfficheQuartier().then(function (response) {
      console.log('Liste Quartier =>', response.data.donner);
      setDataQuartier(response.data.donner);
    }).catch(function (error) {
      console.log(error);
    }).finally(function () {
      setLoadQuartier(false);
    });
  }



  const AfficheCadreData = () => {
    setLoadCadre(true);
    AfficheCadre().then(function (response) {
      console.log('Liste Cadre =>', response.data.donner);
      setDataCadre(response.data.donner);
    }).catch(function (error) {
      console.log(error);
    }).finally(function () {
      setLoadCadre(false);
    });
  }



  const AfficheServiceData = () => {
    setLoadService(true);
    AfficheService().then(function (response) {
      console.log('Liste Service =>', response.data.donner);
      setDataService(response.data.donner);
    }).catch(function (error) {
      console.log(error);
    }).finally(function () {
      setLoadService(false);
    });
  }


  const AfficheRegimeData = () => {
    setLoadRegime(true);
    AfficheRegime().then(function (response) {
      console.log('Liste Service =>', response.data.donner);
      setDataRegime(response.data.donner);
    }).catch(function (error) {
      console.log(error);
    }).finally(function () {
      setLoadRegime(false);
    });
  }


  const AffichePayementData = () => {
    setLoadPayement(true);
    AffichePayement().then(function (response) {
      console.log('Liste Payement =>', response.data.donner);
      setDataPayement(response.data.donner);
    }).catch(function (error) {
      console.log(error);
    }).finally(function () {
      setLoadPayement(false);
    });
  }




  const AfficheBoissonData = () => {
    setLoadBoisson(true);
    AfficheBoisson().then(function (response) {
      console.log('Liste Boisson =>', response.data.donner);
      setDataBoisson(response.data.donner);
    }).catch(function (error) {
      console.log(error);
    }).finally(function () {
      setLoadBoisson(false);
    });
  }

  const handleHero = (e) => {
    var reader = new FileReader();
    if (e.target.files[0]?.type === "image/jpeg" || e.target.files[0]?.type === "image/png" || e.target.files[0]?.type === "image/jpg") {
      reader.readAsDataURL(e.target.files[0]);
      reader.onload = () => {
        var Base64 = reader.result;
        setHero(Base64);
        setIcon(false);
      };
      reader.onerror = (error) => {
        console.log('Error', error);
      };
    } else {
      setErrorHero('Format image accepter PNG, JPEG, JPG');
      const timer = setTimeout(() => setErrorHero(''), 4000);
      return () => clearTimeout(timer);
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoadAdmin(true);

    if (niveau !== "") {
      const data = { nom: nom, prenom: prenom, email: email, niveau: niveau };

      AjouteAdmin(data).then(function (response) {
        if (response.data.title === "success") {
          AfficheAdministration();
          toast.success(response.data?.message);
        }
      }).catch(function (error) {
        console.log(error.response);
        toast.warning(error.response.data?.message);
      }).finally(function () {
        AfficheAdministration();
        setNom('');
        setPrenom('');
        setEmail('');
        setNiveau('');
        setLoadAdmin(false);
      });
    } else {
      toast.warning('Seletioner le niveau');
    }

  }

  const handleDeleteAdmin = (id) => {
    setLoadDeleteAdmin(true);
    SuprimerAdmin(id).then(function (response) {
      if (response.data.title === "success") {
        AfficheAdministration();
        toast.success(response.data?.message);
      }
    }).catch(function (error) {
      console.log(error.response);
      toast.warning(error.response.data?.message);
    }).finally(function () {

      setLoadDeleteAdmin(false);
    });
  }






  const handleAddTypeCuisine = (e) => {
    e.preventDefault();
    setLoadTypeCuisine(true);
    const data = { libelle: typeCuisine };
    AjouteTypeCuisine(data).then(function (response) {
      if (response.data.title === "success") {
        AfficheTypeCuisineData();
        toast.success(response.data?.message);
      }
    }).catch(function (error) {
      console.log(error.response);
      toast.warning(error.response.data?.message);
    }).finally(function () {
      setTypeCuisine('');
      setLoadTypeCuisine(false);
    });
  }


  const handleDeleteTypeCuisine = (idTypeCuisine) => {
    setLoadTypeCuisine(true);
    SuprimerTypeCuisine(idTypeCuisine).then(function (response) {
      if (response.data.title === "success") {
        AfficheTypeCuisineData();
        toast.success(response.data?.message);
      }
    }).catch(function (error) {
      console.log(error.response);
      toast.warning(error.response.data?.message);
    }).finally(function () {
      setLoadTypeCuisine(false);
    });
  }







  const handleAddQuartier = (e) => {
    e.preventDefault();
    setLoadQuartier(true);
    const data = { libelle: quartier };
    AjouteQuartier(data).then(function (response) {
      if (response.data.title === "success") {
        AfficheQuartierData();
        toast.success(response.data?.message);
      }
    }).catch(function (error) {
      console.log(error.response);
      toast.warning(error.response.data?.message);
    }).finally(function () {
      setQuartier('');
      setLoadQuartier(false);
    });
  }


  const handleDeleteQuartier = (idQuartier) => {
    setLoadQuartier(true);
    SuprimerQuartier(idQuartier).then(function (response) {
      if (response.data.title === "success") {
        AfficheQuartierData();
        toast.success(response.data?.message);
      }
    }).catch(function (error) {
      console.log(error.response);
      toast.warning(error.response.data?.message);
    }).finally(function () {
      setLoadQuartier(false);
    });
  }





  const handleAddCadre = (e) => {
    e.preventDefault();
    setLoadCadre(true);
    const data = { libelle: cadre };
    AjouteCadre(data).then(function (response) {
      if (response.data.title === "success") {
        AfficheCadreData();
        toast.success(response.data?.message);
      }
    }).catch(function (error) {
      console.log(error.response);
      toast.warning(error.response.data?.message);
    }).finally(function () {
      setCadre('');
      setLoadCadre(false);
    });
  }


  const handleDeleteCadre = (idCadre) => {
    setLoadCadre(true);
    SuprimerCadre(idCadre).then(function (response) {
      if (response.data.title === "success") {
        AfficheCadreData();
        toast.success(response.data?.message);
      }
    }).catch(function (error) {
      console.log(error.response);
      toast.warning(error.response.data?.message);
    }).finally(function () {
      setLoadCadre(false);
    });
  }







  const handleAddService = (e) => {
    e.preventDefault();
    setLoadService(true);
    const data = { libelle: service };
    AjouteService(data).then(function (response) {
      if (response.data.title === "success") {
        AfficheServiceData();
        toast.success(response.data?.message);
      }
    }).catch(function (error) {
      console.log(error.response);
      toast.warning(error.response.data?.message);
    }).finally(function () {
      setService('');
      setLoadService(false);
    });
  }

  const handleDeleteService = (idService) => {
    setLoadService(true);
    SuprimerService(idService).then(function (response) {
      if (response.data.title === "success") {
        AfficheServiceData();
        toast.success(response.data?.message);
      }
    }).catch(function (error) {
      console.log(error.response);
      toast.warning(error.response.data?.message);
    }).finally(function () {
      setLoadService(false);
    });
  }








  const handleAddRegime = (e) => {
    e.preventDefault();
    setLoadRegime(true);
    const data = { libelle: regime };
    AjouteRegime(data).then(function (response) {
      if (response.data.title === "success") {
        AfficheRegimeData();
        toast.success(response.data?.message);
      }
    }).catch(function (error) {
      console.log(error.response);
      toast.warning(error.response.data?.message);
    }).finally(function () {
      setRegime('');
      setLoadRegime(false);
    });
  }


  const handleDeleteRegime = (idRegime) => {
    setLoadRegime(true);
    SuprimerRegime(idRegime).then(function (response) {
      if (response.data.title === "success") {
        AfficheRegimeData();
        toast.success(response.data?.message);
      }
    }).catch(function (error) {
      console.log(error.response);
      toast.warning(error.response.data?.message);
    }).finally(function () {
      setLoadRegime(false);
    });
  }







  const handleAddPayement = (e) => {
    e.preventDefault();
    setLoadPayement(true);
    const data = { libelle: payement };
    AjoutePayement(data).then(function (response) {
      if (response.data.title === "success") {
        AffichePayementData();
        toast.success(response.data?.message);
      }
    }).catch(function (error) {
      console.log(error.response);
      toast.warning(error.response.data?.message);
    }).finally(function () {
      setPayement('');
      setLoadPayement(false);
    });

  }


  const handleDeletePayement = (idPayement) => {
    setLoadPayement(true);
    SuprimerPayement(idPayement).then(function (response) {
      if (response.data.title === "success") {
        AffichePayementData();
        toast.success(response.data?.message);
      }
    }).catch(function (error) {
      console.log(error.response);
      toast.warning(error.response.data?.message);
    }).finally(function () {
      setLoadPayement(false);
    });
  }







  const handleAddBoisson = (e) => {
    e.preventDefault();
    setLoadBoisson(true);
    const data = { libelle: boisson };
    AjouteBoisson(data).then(function (response) {
      if (response.data.title === "success") {
        AfficheBoissonData();
        toast.success(response.data?.message);
      }
    }).catch(function (error) {
      console.log(error.response);
      toast.warning(error.response.data?.message);
    }).finally(function () {
      setBoisson('');
      setLoadBoisson(false);
    });
  }



  const handleDeleteBoisson = (idBoisson) => {
    setLoadBoisson(true);
    SuprimerBoisson(idBoisson).then(function (response) {
      if (response.data.title === "success") {
        AfficheBoissonData();
        toast.success(response.data?.message);
      }
    }).catch(function (error) {
      console.log(error.response);
      toast.warning(error.response.data?.message);
    }).finally(function () {
      setLoadBoisson(false);
    });
  }

  const handleAddHero = () => {

    if (hero === null || hero === "") {
      toast.warning("Vous devez sélectionner un image");
    } else {
      setLoadData(true);
      const data = { image: hero };
      AjouteHero(data).then(function (response) {
        if (response.data.title === "success") {
          toast.success(response.data?.message);
          AfficheHeroData();
        }
      }).catch(function (error) {
        console.log(error.response);
        toast.warning(error.response.data?.message);
      }).finally(function () {
        setHero();
        setIcon(true);
        setLoadData(false);
      });
    }
  }


  const AfficheHeroData = () => {
    setLoadData(true);
    AfficheHero().then(function (response) {
      console.log('Liste des Images =>', response.data.donner);
      setHeroUrl(response.data.donner[0].imageUrl);
    }).catch(function (error) {
      console.log(error);
    }).finally(function () {
      setLoadData(false);
    });
  }

  const handleCritere = (e) => {
    e.preventDefault();

    setLoadCritere(true);
    const data = { critere: critereAvis };
    AjouteCritereAvis(data).then(function (response) {
      if (response.data.title === "success") {
        toast.success(response.data?.message);
        AfficheCritere();
      }
    }).catch(function (error) {
      console.log(error.response);
      toast.warning(error.response.data?.message);
    }).finally(function () {
      setCritereAvis();
      AfficheCritere();
      setLoadCritere(false);
    });
  }


  const AfficheCritere = () => {
    setLoadCritere(true);
    AfficheCritereAvis().then(function (response) {
      console.log('Liste des criteres =>', response.data.donner);
      setDataCritere(response.data.donner);
    }).catch(function (error) {
      console.log(error);
    }).finally(function () {
      setLoadCritere(false);
    });
  }



  const handleDeletCritere = (id) => {
    setLoadCritere(true);
    SuprimerCritere(id).then(function (response) {
      if (response.data.title === "success") {
        AfficheCritere();
        toast.success(response.data?.message);
      }
    }).catch(function (error) {
      console.log(error.response);
      toast.warning(error.response.data?.message);
    }).finally(function () {
      setLoadCritere(false);
    });
  }



  const handleStatus = (id) => {
    const filterStatus = rechercheRapide.filter((el) => el.status === true);
    const existeId = rechercheRapide.find((el) => el.status === true && el.id === id);
    if (filterStatus.length >= 6 && !existeId) {
      toast.warning("Vous avez atteint 6 critère");
    } else {
      setRechercheRapide((prev) => {
        return prev.map((item) => {
          if (item.id === id) {
            return { ...item, status: !item.status }
          } else {
            return { ...item }
          }
        })
      });
    }

  }

  const handleValue = (id, value) => {
    const filterStatus = rechercheRapide.filter((el) => el.status === true);
    const existeId = rechercheRapide.find((el) => el.status === true && el.id === id);
    if (filterStatus.length >= 6 && !existeId) {
      toast.warning("Vous avez atteint 6 critère");
    } else {
      setRechercheRapide((prev) => {
        return prev.map((item) => {
          if (item.id === id) {
            return { ...item, status: true, value: value }
          } else {
            return { ...item }
          }
        })
      });
    }

  }




  const handleRechercheRapide = () => {
    setLoadRechercheRapide(true);
    const filterStatus = rechercheRapide.filter((el) => el.status === true);

    const data = { critere: filterStatus };

    AjouteRechercheRapide(data).then(function (response) {
      if (response.data.title === "success") {
        toast.success(response.data?.message);
        AfficheCritereRechercheRapide();
      }
    }).catch(function (error) {
      console.log(error.response);
      toast.warning(error.response.data?.message);
    }).finally(function () {
      setLoadRechercheRapide(false);
    });
  }


  const AfficheCritereRechercheRapide = () => {
    setLoadRechercheRapide(true);
    AfficheRechercheRapide().then(function (response) {
      console.log('Liste des recherche rapide =>', response.data.donner);
      response.data.donner.forEach(element => {
        return setRechercheRapide((prev) => {
          return prev.map((item) => {
            if (item.titre === element.titre) {
              return { ...item, value: element.critere, status: true }
            } else {
              return { ...item }
            }
          })
        })
      });
    }).catch(function (error) {
      console.log(error);
    }).finally(function () {
      setLoadRechercheRapide(false);
    });
  }

  const handleStatusPlusReserver = (id) => {
    setPlusReserver((prev) => {
      return prev.map((item) => {
        if (item.id === id) {
          return { ...item, status: true }
        } else {
          return { ...item, status: false, value: "" }
        }
      })
    });
  }

  const handleValuePlusReserver = (id, value) => {
    setPlusReserver((prev) => {
      return prev.map((item) => {
        if (item.id === id) {
          return { ...item, status: true, value: value }
        } else {
          return { ...item, status: false, value: "" }
        }
      })
    });
  }




  const handlePlusReserver = () => {
    setLoadPlusReserver(true);

    const filterStatus = plusReserver.find((el) => el.status === true);

    const data = { plusReserver: filterStatus.value, titre: filterStatus.titre };

    AjoutePlusReserver(data).then(function (response) {
      if (response.data.title === "success") {
        toast.success(response.data?.message);

      }
    }).catch(function (error) {
      console.log(error.response);
      toast.warning(error.response.data?.message);
    }).finally(function () {
      setLoadPlusReserver(false);
    });
  }



  const AfficheCriterePlusReserver = () => {
    setLoadPlusReserver(true);
    AffichePlusReserver().then(function (response) {
      console.log('Liste plus reserver =>', response.data.donner);
      response.data.donner.forEach(element => {
        return setPlusReserver((prev) => {
          return prev.map((item) => {
            if (item.titre === element.titre) {
              return { ...item, value: element.libelle, status: true }
            } else {
              return { ...item }
            }
          })
        })
      });
    }).catch(function (error) {
      console.log(error);
    }).finally(function () {
      setLoadPlusReserver(false);
    });
  }


  const handleUpdateAdmin = (el) => {
    setIdUpdate(el.id);
    setNomUpdate(el.nom);
    setPrenomUpdate(el.prenom);
    setNiveauUpdate(el.niveau);
    setEmailUpdate(el.email);
    setPasswordUpdate(el.valuePassword);
    setShow(true);
  }


  const handleClose = () => setShow(false);



  const handleSubmitUpdate = (e) => {
    e.preventDefault();
    setLoadAdminUpdate(true);
    const data = { nom: nomUpdate, prenom: prenomUpdate, email: emailUpdate, niveau: niveauUpdate, password: passwordUpdate };
    ModifierAdmin(idUpdate, data).then(function (response) {
      AfficheAdministration();
      if (response.data.title === "success") {
        toast.success(response.data?.message);
      }
    }).catch(function (error) {
      console.log(error.response);
      toast.warning(error.response.data?.message);
    }).finally(function () {
      setLoadAdminUpdate(false);
      setShow(false);
    });
  }



  const handleChangePromoMin = (selectedOption) => {
    if (selectedOption) {
      setSelectPromoMin(selectedOption);
    }
  }

  const handlePromotionMin = () => {
    setLoadPromoMin(true);
    const data = { min: selectPromoMin.value };
    AjoutePromoMin(data).then(function (response) {
      if (response.data.title === "success") {
        toast.success(response.data?.message);
        AffichePromotionMin();
      }
    }).catch(function (error) {
      console.log(error.response);
      toast.warning(error.response.data?.message);
    }).finally(function () {
      setLoadPromoMin(false);
    });
  }


    const AffichePromotionMin = () => {
    setLoadPromoMin(true);
    AffichePromoMin().then(function (response) {
      setSelectPromoMin({ value: response.data?.donner[0].min, label: response.data?.donner[0].min + " Jour" })
    }).catch(function (error) {
      console.log(error);
    }).finally(function () {
      setLoadPromoMin(false);
    });
  }


  return (
    <div>
      <Helmet>
        <title>Paramétrage e-kaly</title>
        <meta name='description' content='Paramétrage e-kaly' />
        <link rel='canonical' href={location.pathname} />
      </Helmet>
      <div className='container'>
        <div className='parametrage'>
          <div className='parametrage_content'>
            <Tabs
              defaultActiveKey="admin"
              id="justify-tab-example"
              className="mb-3"
              justify
            >


              <Tab eventKey="admin" title="Administrateurs">
                <div className='para_admin'>
                  <div className='row'>
                    <div className='col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4'>
                      <h2 className='text-center'>Gérer les Administrateurs</h2>
                      <form onSubmit={handleSubmit}>
                        <div className='form_type mt-3'>
                          <select className="form-select form-select-md" value={niveau} onChange={(e) => setNiveau(e.target.value)} required aria-label="Default select example">

                            {dataNiveau.map((el, index) => {
                              if (el.id === 0) {
                                return (
                                  <option selected key={index} value={el.value}>Niveau</option>
                                )
                              } else {
                                return (
                                  <option value={el.value} key={index}>{el.libelle}</option>
                                )
                              }

                            })}
                          </select>
                          <div className="mb-1 mt-2">
                            <label htmlFor="exampleFormControlInput1" className="form-label">Nom</label>
                            <input type="text" className="form-control" value={nom} onChange={(e) => setNom(e.target.value)} required id="exampleFormControlInput1" placeholder="Nom ..." />
                          </div>
                          <div className="mb-1">
                            <label htmlFor="exampleFormControlInput1" className="form-label">Prénom</label>
                            <input type="text" className="form-control" value={prenom} onChange={(e) => setPrenom(e.target.value)} required id="exampleFormControlInput1" placeholder="Prénom" />
                          </div>
                          <div className="mb-1">
                            <label htmlFor="exampleFormControlInput1" className="form-label">Adresse email</label>
                            <input type="email" className="form-control" value={email} onChange={(e) => setEmail(e.target.value)} required id="exampleFormControlInput1" placeholder="Adresse email ..." />
                          </div>

                        </div>
                        {loadAdmin && <div className="d-flex justify-content-center mt-2">
                          <Spinner animation="border" className="load" variant="info" size="md" />
                        </div>}
                        <div className='d-flex justify-content-center mt-4'>
                          <button type="submit" className='btn  btn-sm btn_ajouteAdmin'>Entrer</button>
                        </div>
                      </form>
                    </div>
                    <div className='col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8'>
                      <div className='liste_admine'>
                        <div className='table-responsive'>
                          {loadDeleteAdmin === true ?
                            <div className="d-flex justify-content-center mt-2">
                              <Spinner animation="border" className="load" variant="info" size="md" />
                            </div>
                            :
                            <table className='table table-bordered'>
                              <thead>
                                <tr>
                                  <th>Administrateurs</th>
                                  <th>Adresse email</th>
                                  {societe.niveau === 'Niveau 1' ?
                                    <th>Mot de passe</th> : ''}

                                  <th>Niveau</th>
                                  <th>Supprimer</th>
                                </tr>
                              </thead>

                              <tbody>
                                {
                                  admin.length === 0 ? <tr><td>Liste admin vide</td></tr> :
                                    admin.map((el, index) => {
                                      return (
                                        <tr key={index}>
                                          <td>{el.nom} {el.prenom}</td>
                                          <td>{el.email}</td>
                                          {societe.niveau === 'Niveau 1' ?
                                            <td>{el.valuePassword}</td> : ''}

                                          <td>{el.niveau}</td>
                                          <td>
                                            {societe.niveau === 'Niveau 1' ? <span onClick={() => handleUpdateAdmin(el)}><i className='fa fa-edit'></i></span> : ''}
                                            {societe.niveau === 'Niveau 1' ? <span onClick={() => handleDeleteAdmin(el.id)}><i className='fa fa-trash-o'></i></span> : ''}

                                          </td>
                                        </tr>
                                      )
                                    })
                                }

                              </tbody>

                            </table>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Tab>


              <Tab eventKey="restaurant" title="Donnée Restaurant">
                <div className='para_restaurant'>
                  <div className='row'>
                    <div className='col-12 col-sm-12 col-md-4 col-lg-3 col-sm-3 mt-2'>
                      <div className='typeCuisine'>
                        <h2 className='text-center'>Type de cuisine</h2>
                        <form onSubmit={handleAddTypeCuisine}>
                          <div className='champ'>
                            <input type="text" className="form-control" value={typeCuisine} onChange={(e) => setTypeCuisine(e.target.value)} required placeholder='Type de cuisine ...' />
                            <button className='btn  btn-sm' type="submit"><span >Entrer</span></button>
                          </div>
                        </form>
                        {loadTypeCuisine === true ?
                          <div className="d-flex justify-content-center mt-2">
                            <Spinner animation="border" className="load" variant="info" size="md" />
                          </div> :
                          dataTypeCuisine.length === 0 ? <p>Type cuisine vide ...</p> :
                            dataTypeCuisine.map((item, i) => {
                              return (
                                <div className='typeCuisine_result' key={i}>
                                  <span className='result'>{item.libelle}</span>
                                  <span className='delete_result' onClick={() => handleDeleteTypeCuisine(item.id)}><i className='fa fa-trash-o'></i></span>
                                </div>
                              )
                            })
                        }

                      </div>
                    </div>
                    <div className='col-12 col-sm-12 col-md-4 col-lg-3 col-sm-3 mt-2'>
                      <div className='quartier'>
                        <h2 className='text-center'>Quartier</h2>
                        <form onSubmit={handleAddQuartier}>
                          <div className='champ'>
                            <input type="text" className="form-control" value={quartier} onChange={(e) => setQuartier(e.target.value)} required placeholder='Quartier ...' />
                            <button className='btn  btn-sm' type="submit"><span >Entrer</span></button>
                          </div>
                        </form>
                        {loadQuartier === true ?
                          <div className="d-flex justify-content-center mt-2">
                            <Spinner animation="border" className="load" variant="info" size="md" />
                          </div>
                          : dataQuartier.length === 0 ? <p>Quartier vide ...</p> :
                            dataQuartier.map((item, i) => {
                              return (
                                <div className='quartier_result' key={i}>
                                  <span className='result'>{item.libelle}</span>
                                  <span className='delete_result' onClick={() => handleDeleteQuartier(item.id)}><i className='fa fa-trash-o'></i></span>
                                </div>
                              )
                            })}
                      </div>
                    </div>
                    <div className='col-12 col-sm-12 col-md-4 col-lg-3 col-sm-3 mt-2'>
                      <div className='cadre'>
                        <h2 className='text-center'>Cadre et Ambiance</h2>
                        <form onSubmit={handleAddCadre}>
                          <div className='champ'>
                            <input type="text" className="form-control" value={cadre} onChange={(e) => setCadre(e.target.value)} required placeholder='Cadre et ambiance ...' />
                            <button className='btn  btn-sm' type="submit"><span >Entrer</span></button>
                          </div>
                        </form>
                        {loadCadre === true ?
                          <div className="d-flex justify-content-center mt-2">
                            <Spinner animation="border" className="load" variant="info" size="md" />
                          </div> : dataCadre.length === 0 ? <p>Cadre et ambiance vide ...</p> :
                            dataCadre.map((item, i) => {
                              return (<div className='cadre_result' key={i}>
                                <span className='result'>{item.libelle}</span>
                                <span className='delete_result' onClick={() => handleDeleteCadre(item.id)}><i className='fa fa-trash-o'></i></span>
                              </div>)
                            })}
                      </div>
                    </div>
                    <div className='col-12 col-sm-12 col-md-4 col-lg-3 col-sm-3 mt-2'>
                      <div className='service'>
                        <h2 className='text-center'>Services </h2>
                        <form onSubmit={handleAddService}>
                          <div className='champ'>
                            <input type="text" className="form-control" value={service} onChange={(e) => setService(e.target.value)} required placeholder='Service ...' />
                            <button className='btn  btn-sm' type="submit"><span >Entrer</span></button>
                          </div>
                        </form>
                        {loadService === true ?
                          <div className="d-flex justify-content-center mt-2">
                            <Spinner animation="border" className="load" variant="info" size="md" />
                          </div>
                          : dataService.length === 0 ? <p>Service vide ...</p> :
                            dataService.map((el, i) => {
                              return (
                                <div className='service_result' key={i}>
                                  <span className='result'>{el.libelle}</span>
                                  <span className='delete_result' onClick={() => handleDeleteService(el.id)}><i className='fa fa-trash-o'></i></span>
                                </div>
                              )
                            })}
                      </div>
                    </div>
                    <div className='col-12 col-sm-12 col-md-4 col-lg-3 col-sm-3 mt-2'>
                      <div className='regime'>
                        <h2 className='text-center'>Régime alimentaire spécifique </h2>
                        <form onSubmit={handleAddRegime}>
                          <div className='champ'>
                            <input type="text" className="form-control" value={regime} onChange={(e) => setRegime(e.target.value)} required placeholder='Régime ...' />
                            <button className='btn  btn-sm' type="submit"><span >Entrer</span></button>
                          </div>
                        </form>
                        {loadRegime === true ?
                          <div className="d-flex justify-content-center mt-2">
                            <Spinner animation="border" className="load" variant="info" size="md" />
                          </div>
                          : dataRegime.length === 0 ? <p>Régime alimentaire vide ...</p> :
                            dataRegime.map((item, i) => {
                              return (
                                <div className='regime_result' key={i}>
                                  <span className='result'>{item.libelle}</span>
                                  <span className='delete_result' onClick={() => handleDeleteRegime(item.id)}><i className='fa fa-trash-o'></i></span>
                                </div>
                              )
                            })
                        }
                      </div>
                    </div>
                    <div className='col-12 col-sm-12 col-md-4 col-lg-3 col-sm-3 mt-2'>
                      <div className='payement'>
                        <h2 className='text-center'>Mode de payement </h2>
                        <form onSubmit={handleAddPayement}>
                          <div className='champ'>
                            <input type="text" className="form-control" value={payement} onChange={(e) => setPayement(e.target.value)} required placeholder='Payement ...' />
                            <button className='btn btn-sm' type="submit"><span >Entrer</span></button>
                          </div>
                        </form>
                        {loadPayement === true ?
                          <div className="d-flex justify-content-center mt-2">
                            <Spinner animation="border" className="load" variant="info" size="md" />
                          </div> : dataPayement.length === 0 ? <p>Payement vide ...</p> :
                            dataPayement.map((item, i) => {
                              return (
                                <div className='payement_result' key={i}>
                                  <span className='result'>{item.libelle}</span>
                                  <span className='delete_result' onClick={() => handleDeletePayement(item.id)}><i className='fa fa-trash-o'></i></span>
                                </div>
                              )
                            })}
                      </div>
                    </div>
                    <div className='col-12 col-sm-12 col-md-4 col-lg-3 col-sm-3 mt-2'>
                      <div className='boisson'>
                        <h2 className='text-center'>Boissons</h2>
                        <form onSubmit={handleAddBoisson}>
                          <div className='champ'>
                            <input type="text" className="form-control" value={boisson} onChange={(e) => setBoisson(e.target.value)} required placeholder='Boisson ...' />
                            <button className='btn btn-sm' type="submit"><span >Entrer</span></button>
                          </div>
                        </form>
                        {loadBoisson === true ?
                          <div className="d-flex justify-content-center mt-2">
                            <Spinner animation="border" className="load" variant="info" size="md" />
                          </div> : dataBoisson.length === 0 ? <p>Boisson vide ...</p> :
                            dataBoisson.map((item, i) => {
                              return (
                                <div className='boisson_result' key={i}>
                                  <span className='result'>{item.libelle}</span>
                                  <span className='delete_result' onClick={() => handleDeleteBoisson(item.id)}><i className='fa fa-trash-o'></i></span>
                                </div>
                              )
                            })}
                      </div>
                    </div>
                  </div>
                </div>
              </Tab>








              <Tab eventKey="accueil" title="Configuration page">
                <div className='para_accueil'>
                  <div className='row'>
                    <div className='col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3'>
                      <div className='para_imageHeader'>
                        <h2 className='text-center'>Image Accueil</h2>
                        <div className='image_hero'>
                          <div className='image_appareil'>
                            <input type="file" className="form-control" id="fileHero" onChange={(e) => handleHero(e)} required />
                            <label htmlFor="fileHero" className="d-flex justify-content-center" id="fileLabel">
                              {icon === true ?
                                <div className='avatarHero d-flex justify-content-center align-items-center'>
                                  <i className='fa fa-picture-o'></i>
                                </div>

                                : <img src={hero} alt="hero restaurant" className='hero_restaurant' />

                              }
                            </label>
                          </div>
                          <div className="d-flex justify-content-center">
                            {errorHero !== "" ? <span className="errorValue">{errorHero}</span> : ''}
                          </div>
                          <div className='d-flex justify-content-center'>
                            <button className='btn btn-sm btn_ajoute_hero' onClick={handleAddHero}>Ajouter</button>
                          </div>
                          {loadData === true ? <div className="d-flex justify-content-center mt-2">
                            <Spinner animation="border" className=" load" variant="info" size="md" />
                          </div> : heroUrl === "" ? ''
                            : <div className='image_hero'>
                              <div className='image_appareil'>
                                <img src={BASE_URL + heroUrl} alt="hero restaurant" className='hero_restaurant' />
                              </div>
                            </div>}

                        </div>
                      </div>
                    </div>
                    <div className='col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3'>
                      <div className="critereAvis">
                        <h2 className='text-center'>Critère avis</h2>
                        <form onSubmit={handleCritere}>
                          <div className='form_critere'>
                            <input type="text" value={critereAvis} onChange={(e) => setCritereAvis(e.target.value)} required className='form-control form-control-sm' placeholder='Critère ...' />
                            <button type='submit' className='btn btn-sm'>Ajoute</button>
                          </div>
                        </form>
                        {loadCritere === true ?
                          <div className="d-flex justify-content-center mt-4">
                            <Spinner animation="border" className="load" variant="info" size="md" />
                          </div>
                          :
                          <div className='donner_critere'>
                            {dataCritere.length !== 0 ?
                              dataCritere.map((element, index) => {
                                return (<div className='liste_critere' key={index}>
                                  <span className='result'>{element.critere}</span>
                                  <span className='delete_result' onClick={() => handleDeletCritere(element.id)}><i className='fa fa-trash-o'></i></span>
                                </div>)
                              })
                              : <p>Critère vide ...</p>}
                          </div>}
                      </div>
                    </div>
                    <div className='col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3'>
                      <div className="rechercheRapide">
                        <h2 className='text-center'>Critère recherche rapide (max 6)</h2>
                        <div className="listeRecherche_rapide">
                          {rechercheRapide.map((el, index) => {
                            if (el.titre === "Ville") {
                              return (
                                <div className="form-check" key={index}>
                                  <input className="form-check-input" type="checkbox" onChange={() => handleStatus(el.id)} id={el.titre + "inlineCheckbox1"} checked={el.status} defaultValue={el.titre + "option1"} />
                                  <input type="text" className="form-control form-control-sm" value={el.value} onChange={(e) => handleValue(el.id, e.target.value)} placeholder="Ville..." />
                                </div>
                              )
                            } else if (el.titre === "Type de cuisine") {
                              return (
                                <div className="form-check" key={index}>
                                  <input className="form-check-input" type="checkbox" onChange={() => handleStatus(el.id)} id={el.titre + "inlineCheckbox1"} checked={el.status} defaultValue={el.titre + "option1"} />
                                  <input type="text" className="form-control form-control-sm" value={el.value} onChange={(e) => handleValue(el.id, e.target.value)} placeholder="Cuisinne..." />
                                </div>
                              )
                            } else {
                              return (
                                <div className="form-check" key={index}>
                                  <input className="form-check-input" type="checkbox" onChange={() => handleStatus(el.id)} id={el.titre + "inlineCheckbox1"} checked={el.status} defaultValue={el.titre + "option1"} />
                                  <label className="form-check-label" htmlFor={el.titre + "inlineCheckbox1"}>{el.titre}</label>
                                </div>
                              )
                            }

                          })}

                        </div>

                        {loadRechercheRapide === true ?
                          <div className="d-flex justify-content-center mt-4">
                            <Spinner animation="border" className="load" variant="info" size="md" />
                          </div>
                          :
                          <div className='d-flex justify-content-center'>
                            <button className='btn btn-sm btn_enregistrer' onClick={handleRechercheRapide}>Enregistrer</button>
                          </div>}

                      </div>
                    </div>
                    <div className='col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3'>
                      <div className="plusReserver">
                        <h2 className='text-center'>Critère les plus réservés</h2>
                        <div className='listePlusReserver'>
                          <div>
                            {plusReserver.map((el, index) => {
                              return (
                                <div className="form-check" key={index}>
                                  <input className="form-check-input" type="radio" checked={el.status} onChange={() => handleStatusPlusReserver(el.id)} name="flexRadioDefault" id={el.titre} />
                                  <input type="text" className="form-control form-control-sm" value={el.value} onChange={(e) => handleValuePlusReserver(el.id, e.target.value)} placeholder={el.placeholder} />
                                </div>
                              )
                            })}
                          </div>
                        </div>
                        {loadPlusReserver === true ?
                          <div className="d-flex justify-content-center mt-4">
                            <Spinner animation="border" className="load" variant="info" size="md" />
                          </div>
                          :
                          <div className='d-flex justify-content-center'>
                            <button className='btn btn-sm btn_enregistrer' onClick={handlePlusReserver}>Enregistrer</button>
                          </div>}
                      </div>
                    </div>
                    <div className='col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3'>
                      <div className="plusReserver">
                        <h2 className='text-center'>Promotions valables pour un minimum de X jours</h2>
                        <div className='listePlusReserver' style={{marginTop:'20px'}}>
                          <Select
                            className="select-user"
                            value={selectPromoMin}
                            styles={customStyles}
                            onChange={handleChangePromoMin}
                            options={promoMinOptions}
                            placeholder="Min ..."
                          />
                        </div>
                        {loadPromoMin === true ?
                          <div className="d-flex justify-content-center mt-4">
                            <Spinner animation="border" className="load" variant="info" size="md" />
                          </div>
                          :
                          <div className='d-flex justify-content-center'>
                            <button className='btn btn-sm btn_enregistrer' onClick={handlePromotionMin}>Enregistrer</button>
                          </div>}
                      </div>
                    </div>
                  </div>
                </div>


              </Tab>
            </Tabs>






          </div>
          <p className="version">Version 1</p>
        </div>

      </div>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Modification Administrateurs</Modal.Title>
        </Modal.Header>
        <form onSubmit={handleSubmitUpdate}>
          <Modal.Body>
            <select className="form-select form-select-md" value={niveauUpdate} onChange={(e) => setNiveauUpdate(e.target.value)} required aria-label="Default select example">

              {dataNiveau.map((el, index) => {
                if (el.id === 0) {
                  return (
                    <option selected key={index} value={el.value}>Niveau</option>
                  )
                } else {
                  return (
                    <option value={el.value} key={index}>{el.libelle}</option>
                  )
                }

              })}
            </select>
            <div className="mb-1 mt-2">
              <label htmlFor="exampleFormControlInput1" className="form-label">Nom</label>
              <input type="text" className="form-control" value={nomUpdate} onChange={(e) => setNomUpdate(e.target.value)} required id="exampleFormControlInput1" placeholder="Nom ..." />
            </div>
            <div className="mb-1">
              <label htmlFor="exampleFormControlInput1" className="form-label">Prénom</label>
              <input type="text" className="form-control" value={prenomUpdate} onChange={(e) => setPrenomUpdate(e.target.value)} required id="exampleFormControlInput1" placeholder="Prénom" />
            </div>
            <div className="mb-1">
              <label htmlFor="exampleFormControlInput1" className="form-label">Adresse email</label>
              <input type="email" className="form-control" value={emailUpdate} onChange={(e) => setEmailUpdate(e.target.value)} required id="exampleFormControlInput1" placeholder="Adresse email ..." />
            </div>
            <div className="mb-1">
              <label htmlFor="exampleFormControlInput1" className="form-label">Mot de passe</label>
              <input type="password" className="form-control" value={passwordUpdate} onChange={(e) => setPasswordUpdate(e.target.value)} required id="exampleFormControlInput1" placeholder="Mot de passe ..." />
            </div>


          </Modal.Body>
          {loadAdminUpdate ? <div className="d-flex justify-content-center mt-2 mb-4">
            <Spinner animation="border" className="load" variant="info" size="md" />
          </div> :
            <div className='d-flex justify-content-center mb-4 mt-2'>
              <Button variant="success" type="submit">
                Modifier
              </Button>
            </div>
          }
        </form>
      </Modal>
    </div>
  )
}

export default ParametragePage